import * as React from "react";
export default function Spinner({ size, position }) {
    return (React.createElement("div", { className: "spinner-container" },
        React.createElement("div", { className: `lds-ring ${size} ${position !== null && position !== void 0 ? position : ""}` },
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null),
            React.createElement("div", null))));
}
